import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button
} from "@chakra-ui/react";
import { useTypedSelector } from "store/hooks";
import { ResultadoPonto } from "pages/ConsultaPrevia/components/ResultadoPonto";

interface ModalConsultaPreviaProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * A consulta prévia do ponto marcado no formulário. Mostra exatamente o que a
 * tela de consulta prévia mostra: mesmo endpoint, mesmo componente.
 */
export const ModalConsultaPrevia = ({
  isOpen,
  onClose
}: ModalConsultaPreviaProps) => {
  const { isRequesting, successPayload, errors } = useTypedSelector(
    (state) => state.consultaprevia.obterPlanoDiretorNoPonto
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Consulta prévia do plano diretor</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ResultadoPonto
            isRequesting={isRequesting}
            resultado={successPayload}
            errors={errors}
          />
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
